/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

/**
 * Refresh ONLY cart drawer inner content
 * Compatible with custom Drawer class (keeps isOpen state)
 */
/**
 * Refresh ONLY cart drawer inner content
 * Compatible with custom Drawer class
 */
/**
 * Refresh ONLY cart drawer inner content
 * Multilanguage-safe + Drawer-safe
 */
/**
 * Refresh cart drawer by fetching FULL /cart page
 * Works with custom Drawer class + multilingual routes
 */
/**
 * Add gift to cart and let THEME handle refresh
 */
document.addEventListener('click', (e) => {
  const toggle = e.target.closest('[data-gift-toggle]');
  if (!toggle) return;

  const panel = toggle.nextElementSibling;
  const icon = toggle.querySelector('.CartGift__Icon');

  const isOpen = panel.classList.toggle('is-open');
  toggle.setAttribute('aria-expanded', isOpen);
  icon.textContent = isOpen ? '−' : '+';
});

document.addEventListener('click', async (e) => {
  const trigger = e.target.closest('[data-gift-add]');
  if (!trigger) return;

  const variantId = trigger.dataset.giftVariantId;
  if (!variantId) return;

  console.group('[GIFT] add free gift');

  try {
    const res = await fetch(`${Shopify.routes.root}cart/add.js`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({
        id: Number(variantId),
        quantity: 1,
        properties: {
          _box: 'true'
        }
      })
    });

    console.log('[GIFT] add.js status:', res.status);

    const json = await res.json();
    console.log('[GIFT] response:', json);

    console.log('[GIFT] dispatch cart:refresh on <html>');
    document.documentElement.dispatchEvent(
      new CustomEvent('cart:refresh', { bubbles: true })
    );

  } catch (err) {
    console.error('[GIFT] ERROR', err);
  }

  console.groupEnd();
});

